import { Configuration, LogLevel } from '@azure/msal-browser';

// Get configuration from window.ENV (loaded from config.js) or import.meta.env for local development
const getConfig = (key: string): string => {
  const value = (window as any).ENV?.[key] || import.meta.env[key] || '';

  // Log warning for critical missing configuration
  if (!value && key === 'VITE_AZURE_CLIENT_ID') {
    console.error(`Critical: ${key} is not configured. Authentication will not work.`);
    console.error('Please ensure config.js or config.local.js is loaded and contains the client ID.');
    console.error('Current window.ENV:', (window as any).ENV);
  }

  return value;
};

// MSAL configuration - now a function that returns the config dynamically
export const getMsalConfig = (): Configuration => ({
  auth: {
    clientId: getConfig('VITE_AZURE_CLIENT_ID'),
    authority: 'https://login.microsoftonline.com/common', // Multi-tenant endpoint
    redirectUri: getConfig('VITE_REDIRECT_URI') || window.location.origin,
    navigateToLoginRequestUrl: false, // Prevent redirect loops
  },
  cache: {
    cacheLocation: 'sessionStorage', // Use sessionStorage to avoid conflicts with cart in localStorage
    storeAuthStateInCookie: true, // Store auth state in cookies for better cross-tab support
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        
        // Check for authorization errors in log messages
        if (message.includes('AADSTS65001') || // Consent required
            message.includes('AADSTS50076') || // MFA required but app not approved
            message.includes('AADSTS90094') || // Admin consent required
            message.includes('AADSTS90095') || // Admin has not consented
            message.includes('AADSTS65004') || // User declined consent
            message.includes('AADSTS700003') || // Device auth required but not approved
            message.includes('AADSTS7000112') || // Application disabled
            message.includes('AADSTS700016')) { // Application not found in directory
          console.error('Authorization error detected:', message);
          // Redirect to authorization needed page
          window.location.href = '/authorization-needed';
          return;
        }
        
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            // console.info(message);
            return;
          case LogLevel.Verbose:
            // console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
});

// Scopes for Microsoft Graph API
export const loginRequest = {
  scopes: ['User.Read', 'email'], // Basic user profile information
};
